module.exports = __webpack_public_path__ + "static/media/group-4.fa7471ff.png";